<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/05/Blog_1920x324.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Blog</h1>
    </div>
  </section>

  <!-- wrap-highlights -->
  <section class="wrap-highlights">
    <div class="layout">
      <div class="list-hightlights">
        <a class="post" id="post-{{postsRecentes[0]?.id}}"
          (click)="navigateToPost(postsRecentes[0].slug, postsRecentes[0].id)"
          style="background-image: url('{{postsRecentes[0]?.link_img}}');">
          <h2 class="post-title"> {{postsRecentes[0]?.titulo}}</h2>
        </a>
        <a class="post" id="post-{{postsRecentes[1]?.id}}"
          (click)="navigateToPost(postsRecentes[1]?.slug, postsRecentes[1].id)"
          style="background-image: url('{{postsRecentes[1]?.link_img}}');">
          <h2 class="post-title"> {{postsRecentes[1]?.titulo}}</h2>
        </a>
        <a class="post" id="post-{{postsRecentes[2]?.id}}"
          (click)="navigateToPost(postsRecentes[2].slug, postsRecentes[2].id)"
          style="background-image: url('{{postsRecentes[2]?.link_img}}');">
          <h2 class="post-title"> {{postsRecentes[2]?.titulo}}</h2>
        </a>
      </div>
    </div>
  </section>


  <section class="wrap-popular">
    <div class="layout">
      <h2 class="subtitle">As mais lidas</h2>
      <div class="list-posts">

        <a *ngFor="let post of this.destaque" class="post" id="post-{{post?.id}}"
          (click)="navigateToPost(post.slug, post?.id)">
          <div class="photo" style="background-image: url('{{post?.link_img}}');">
          </div>
          <div class="infos">
            <h2 class="post-title">{{post?.titulo}}</h2>
          </div>
        </a>


      </div>
    </div>
  </section>

  <section class="wrap-posts">
    <div class="layout">
      <h2 class="subtitle">Publicações</h2>

      <div class="left">
        <div *ngFor="let post of this.posts" class="all-posts">

          <a class="post" id="post-{{post?.id}}" (click)="navigateToPost(post.slug, post?.id)">
            <div class="photo" style="background-image: url('{{post?.link_img}}');"></div>
            <div class="infos">
              <h2 class="post-title">{{post?.titulo}}</h2>
              <p class="post-date">{{post.data_criacao | date:'dd/MM/yyyy'}}</p>
              <p class="post-resume"></p>
              <p>{{post.descricao}} […]</p>
              <p></p>
            </div>
          </a>
        </div>

        <pagination class="pagination" [maxSize]="5" [totalItems]="totalItems" [itemsPerPage]="itemsPerPage"
          [(ngModel)]="currentPage" (pageChanged)="pageChanged($event)" [boundaryLinks]="true" [rotate]="false"
          [previousText]="'Anterior'" [nextText]="'Próximo'" [firstText]="'Primeira'" [lastText]="'Última'">
        </pagination>
      </div>

      <aside class="sidebar">
        <div class="box">
          <h2 class="subtitle category">Categorias</h2>
          <div class="list-category d-flex flex-column">
            <a class="category" [routerLink]="['/blog', 'seguranca']">Segurança</a>
            <a class="category" [routerLink]="['/blog', 'manutencao']">Manutenção</a>
            <a class="category" [routerLink]="['/blog', 'vistoria']">Vistoria</a>
            <a class="category" [routerLink]="['/blog', 'seminovos']">Seminovos</a>
            <a class="category" [routerLink]="['/blog', 'consulta-veicular']">Consulta Veicular</a>
            <a class="category" [routerLink]="['/blog', 'gestao']">Gestão</a>
            <a class="category" [routerLink]="['/blog', 'sem-categoria']">Sem categoria</a>
            <a class="category" [routerLink]="['/blog']">Todas as postagens</a>
          </div>
        </div>
      </aside>
    </div>
  </section>
</main>
